<template>
    <div>
        <ResumeCard
            title="Miscellaneous"
            icon="mdi-lightbulb-on-outline"
            color="cyan"
            width="100%"
            min-height="550">
            <v-row class="tools pa-4">
                <div
                    v-for="tool in tools"
                    :key="tool.name"
                    class="tool col-center py-3">
                    <div class="tool__logo col-center">
                        <img
                            :src="tool.logo"
                            :alt="tool.name" />
                    </div>
                    <span class="secondary--text text-caption">{{ tool.name }}</span>
                </div>
            </v-row>
        </ResumeCard>
    </div>
</template>

<script>
import { tools } from '@/data/skills';
import ResumeCard from './ResumeCard.vue';

export default {
    name: 'ToolsPanel',
    components: { ResumeCard },
    data: () => ({ tools }),
};
</script>

<style scoped>
.tools {
    justify-content: space-around;
}
.tool {
    min-width: 110px;
}
.tool__logo {
    min-width: 64px;
    max-width: 95px;
    height: 64px;
}
.tool__logo img {
    max-width: 100%;
    max-height: 90px;
}
/* Light logos on the darkened twilight card, keeping their hue. */
[data-theme='twilight'] .tool__logo img {
    filter: invert(1) hue-rotate(180deg);
}
@media (min-width: 960px) {
    .tool__logo {
        min-width: 150px;
        max-width: 185px;
        height: 128px;
    }
}
</style>
